export module Consent {
    export interface Category {
        categorySlug: string;
        description: string;
        isEssential: Boolean;
        isHidden: Boolean;
        label: string;
        status: Boolean;
        isIntermediateState: Boolean;
        consents: Consent[];
    }
    export enum CategoryStatus {
        intermediate,
        yes,
        no
    }
    export interface Consent {
        consentId?: string;
        controllerId: string;
        processorId: string;
        categorySlug: string;
        defaultConsentStatus: boolean;
        consentStatus: boolean;
        unsavedConsentStatus: boolean;
        description: string;
        isDeactivated: boolean;
        isHidden: boolean;
        isShared: boolean;
        subConsents?: Consent[];
        templateId: string;
        version: string;
        action: string;
        updatedBy: string;
        history: History[];
    }
    export interface History {
        action: string;
        updatedBy: string;
        appVersion: string;
        settingsVersion: string;
        consentTemplateVersion: string;
        consentStatus: Boolean;
        language: string;
        updatedAt: number;
        templateId: string;
    }
    export interface ConsentTemplate {
        templateId: string;
        version: string;
        language: string;
        adminSettingsId: string[];
        linkToDpa: string;
        defaultConsentStatus: Boolean;
        dataAttributes: string[]; // dataCollectedList
        dataProcessors: string[];
        dataPurposes: string[];
        domAttributes: string[];
        domElements: string[];
        domKeys: string[];
        legalGround: string;
        locationOfProcessing: string;
        processingCompany: string;
        optOutUrl: string;
        policyOfProcessorUrl: string;
        description: string;
        defaultCategoryLabel: string;
        defaultCategorySlug: string;
        recordsOfProcessingActivities: string;
        retentionPeriod: number;
        retentionPeriodDescription: string;
        technologyUsed: string[];
        technologyUsedDescription?: string;
        iabId: number;
        tagLoggerMatchingId: string;
        isShared: Boolean;
        isDeactivated: Boolean;
        isHidden: Boolean;
        dataProtectionOfficer: string;
        dataCollectedDescription: string;
        dataPurposesDescription: string;
        dataRecipientsDescription: string;
        legalBasisDescription: string;
        optOutDescription: string;
        thirdCountryTransfer: string;
        privacyPolicyURL: string;
        cookiePolicyURL: string;
        dataPurposesList: string[];
        dataRecipientsList: string[];
        legalBasisList: string[];
        retentionPeriodList: string[];
        subConsents: string[];
        cookieNames: string[];
        
        descriptionOfService?: string;
        nameOfProcessingCompany?: string;
        addressOfProcessingCompany?: string;
        dataCollectedList?: string[];
    }

    export interface ConsentTemplates {
        [key: string]: {
            [key: string]: ConsentTemplate
        }
    }

    export interface ConsentCopyFields {
        copiedConsentId: Boolean;
        copiedControllerId: Boolean;
        copiedProcessorId: Boolean;
    }

    export interface ConsentToggleFields {
        showDetail: boolean;
        showSubConsents: boolean;
        showHistory: boolean;
    }
}